import { InjectionToken } from '@angular/core';

import { CalculatedOdds } from '@frontend/sports/odds/feature';
import { Decimal } from 'decimal.js';
import { Observable } from 'rxjs';

export interface IContainerSummary {
    possibleWinnings: Decimal | null;
    totalOdds?: CalculatedOdds;
    /**
     * Boosted odds resulting of applied odds boost token
     */
    boostedOdds?: CalculatedOdds | null;
    /**
     * Boosted winnings resulting of applied odds boost token
     */
    boostedWinnings?: Decimal | null;
    /**
     * Acca boost original winnings value, acca boosted winnings set to possibleWinnings
     */
    originalWinnings?: Decimal | null;
    hasOddsUpdate: boolean;
    /**
     * Possible winnings that cannot be evaluated yet, e.g. SP pick for Horseracing
     */
    showEmptyPossibleWinnings?: boolean;
}

export const LINEAR_CONTAINER_SUMMARY_SERVICE = new InjectionToken<ILinearContainerSummaryService>('LINEAR_CONTAINER_SUMMARY_SERVICE');

export interface ILinearContainerSummaryService {
    getSummary$(): Observable<IContainerSummary | null>;
}
